import Player from '@vimeo/player';

export default (target) => ({
  open: false,
  originContent: '',
  contentElement: null,
  modal: null,
  target: target,
  close: '',
  sourceElement: null,

  handleModal() {
    this.sourceElement = this.$el;
    const source = this.sourceElement.dataset.source;
    const targetContent = this.modal.querySelector('.alpine-modal__content');
    if (source.indexOf('vimeo') == 0) {
      this.$dispatch('set-modal', false)
      const vimeoId = source.substring(6);
      this.handleVimeo(vimeoId, targetContent);
      if (this.$el.querySelector("iframe")) {
        this.$el.querySelector("iframe").contentWindow.postMessage('{"method":"pause"}', '*');
      }
    }
    else if (source.indexOf('#') == 0) {
      this.fetchContent(source.substring(1), targetContent);
      this.$dispatch('set-modal', true)

    }
    else {
      this.$dispatch('set-modal', true)
      this.getContent(source, targetContent);
    }
  },

  openModal() {
    document.body.classList.add('stop-scrolling');
    this.close.classList.remove('alpine-modal__close--hidden');
    this.modal.classList.add('alpine-modal--open');
  },

  closeModal(close = true) {
    if (close) {
      this.modal.classList.remove('alpine-modal--open');
    }
    this.close.classList.add('alpine-modal__close--hidden');
    document.body.classList.remove('stop-scrolling');
    this.revertContent();
    this.contentElement = null;
    if (this.sourceElement && this.sourceElement.querySelector('iframe')) {
      this.sourceElement.querySelector('iframe').contentWindow.postMessage('{"method":"play"}', '*');
    }
    this.sourceElement = null;
  },

  handleVimeo(vimeoId, target) {
    this.originContent = `<div class="alpine-modal-video"><iframe src="https://player.vimeo.com/video/${vimeoId}?portrait=0&byline=0&quality=auto&title=0" allow="autoplay"></iframe></div>`;
    this.handleContent(target);
    const iframe = target.querySelector('iframe');
      const player = new Player(iframe);
      player.play();
    setTimeout(() => {
      this.openModal();
    }, 400);
  },

  getContent(source, target) {
    this.contentElement = document.getElementById(source);
    this.originContent = `${this.contentElement.innerHTML}`;
    this.handleContent(target);
    setTimeout(() => {
      this.openModal();
    }, 400);
  },

  fetchContent(source, target) {
    fetch(source)
      .then((response) => response.text())
      .then((html) => {
        const wrapper = document.createElement('div');
        wrapper.classList.add('program-modal-wrapper');
        const content = document.createElement('div');
        content.classList.add('program-modal');
        content.innerHTML = html;
        wrapper.appendChild(content);
        const tmp = document.createElement('div');
        tmp.appendChild(wrapper);
        target.innerHTML = tmp.innerHTML;
      })
      .then(() => {
        this.openModal();
      });
  },

  revertContent() {
    if (this.contentElement !== null) {
      this.contentElement.innerHTML = this.originContent;
    } else {
      this.modal.querySelector('.alpine-modal__content').innerHTML = '';
    }
  },

  handleContent(target) {
    target.innerHTML = this.originContent;
  },

  init() {
    this.modal = document.getElementById(target);
    this.close = this.modal.querySelector('.alpine-modal__close');
  },
});
